import { useMutation } from 'react-query';

import { MutationFunction, useRequest } from '@frontend/api';

import {
  UploadQuoteFilesRequestData,
  UploadQuoteFilesResponseData,
} from './types';

export const useUploadQuoteFiles: MutationFunction<
  UploadQuoteFilesResponseData,
  UploadQuoteFilesRequestData
> = ({ requestOptions, queryOptions } = {}) => {
  const request = useRequest(requestOptions);
  return useMutation(
    (requestData) => {
      const { quoteId } = requestData;
      return request<UploadQuoteFilesResponseData>(
        `/quotes/${quoteId}/quote_file_upload`,
        {
          ...requestOptions,
          init: { method: 'POST', body: requestData.files },
        },
      );
    },
    {
      ...queryOptions,
      mutationKey: ['uploadQuoteFiles'],
    },
  );
};
